module.exports = Object.freeze({
  STEPS_TITLES: ['Avatar', 'Goal', 'Start'],
});
